module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('SubHeader', {
    attrs: {
      "slot": "sub-header",
      "title": _vm.$t('bookmark.title')
    },
    slot: "sub-header"
  }, [_c('div', {
    attrs: {
      "slot": "sub-header-tab"
    },
    slot: "sub-header-tab"
  }, [_c('SubHeaderTab', {
    attrs: {
      "items": _vm.lecturesType,
      "isStaticTab": true,
      "selectedId": _vm.selectedLectureType
    },
    on: {
      "selectedTab": _vm.selectedTab
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bookmark row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.busy) ? _c('LoadingBounce', {
    staticClass: "w-100"
  }) : [(_vm.selectedLectureType === _vm.videoLectureType) ? [(_vm.bookmarksLecture.length === 0) ? _c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('bookmark.empty_vidoe_lecture')
    }
  }) : [_vm._l((_vm.bookmarksLecture), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "col-lg-3 col-md-3 col-sm-6 col-12 px-6 mb-2 mt-6"
    }, [_c('VideoCard', {
      attrs: {
        "videoLecture": item,
        "eventLabel": 'bookmarked_video_lecture'
      }
    })], 1)
  }), _vm._v(" "), (_vm.bookmarksLecture.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()]] : _vm._e(), _vm._v(" "), (_vm.selectedLectureType === _vm.cardLectureType) ? [(_vm.bookmarksLecture.length === 0) ? _c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('empty_card_lecture')
    }
  }) : [_vm._l((_vm.bookmarksLecture), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "col-lg-3 col-md-3 col-sm-6 col-12 px-6 mb-2 mt-6"
    }, [_c('ImageCard', {
      attrs: {
        "cardLecture": item,
        "eventLabel": 'bookmarked_card_lecture'
      }
    })], 1)
  }), _vm._v(" "), (_vm.bookmarksLecture.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()]] : _vm._e()]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02bdfc4b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/bookmark/views/Bookmark.vue
// module id = 1547
// module chunks = 1